import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { buildTitle } from "@/config/seoTitles";
import { notFoundUnlessRedirected } from "@/lib/slugGuards";

const PartnerLanding = lazy(() => import("@/pages/PartnerLanding"));

export const Route = createFileRoute("/bli-partner/$slug")({
  loader: async ({ params }) => {
    const { partnerSegments } = await import("@/data/partnerSegments");
    const s = partnerSegments.find((x) => x.slug === params.slug);
    // Okänt partnersegment: riktig 404 (sidan skickade annars vidare först i webbläsaren).
    if (!s) await notFoundUnlessRedirected(`/bli-partner/${params.slug}`);
    return { segment: s ? { metaTitle: s.metaTitle, metaDescription: s.metaDescription } : null };
  },
  head: ({ params, loaderData }) => {
    const segment = loaderData?.segment;
    return seoHead(`/bli-partner/${params.slug}`, {
      ...(segment
        ? { title: buildTitle(segment.metaTitle), description: segment.metaDescription }
        : {}),
    });
  },
  component: () => <PartnerLanding />,
});
